/** @file Field check for a fixed-length array of numbers (vectors, sizes, ranges). */
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';
import type { NumberRule } from '@zilo/pose3d-format/validate/fields/checkNumber';
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check for an array of exactly `length` finite numbers obeying `rule`. */
export function checkTuple(length: number, rule: NumberRule = {}): FieldCheck {
  const item = checkNumber(rule);
  return (value, path) => {
    if (!Array.isArray(value) || value.length !== length) failField(path, `array of ${length} numbers`, value);
    (value as unknown[]).forEach((v, i) => { item(v, `${path}/${i}`); });
  };
}
